import { graphql } from 'react-relay';

export const applyRefund = graphql`
  mutation applyRefundMutation(
    $refundId: String!
    $phoneNumber: String!
    $bank: String!
    $accountOwner: String!
    $accountNo: String!
    $metaProperties: String
    $autographImageKey: String
    $delegationFileKey: String
    $utmSource: String
    $utmMedium: String
    $utmCampaign: String
    $utmTerm: String
    $utmContent: String
  ) {
    applyRefund(
      refundId: $refundId
      phoneNumber: $phoneNumber
      bank: $bank
      accountOwner: $accountOwner
      accountNo: $accountNo
      metaProperties: $metaProperties
      autographImageKey: $autographImageKey
      delegationFileKey: $delegationFileKey
      applyUtm: { source: $utmSource, medium: $utmMedium, campaign: $utmCampaign, term: $utmTerm, content: $utmContent }
    ) {
      result
      errors {
        code
      }
    }
  }
`;
